import * as React from 'react';
import { Notification } from '@progress/kendo-react-notification';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface TopRightToastProps {
  message: string;
  type?: ToastType;
  onClose: () => void;
}

export const Toast: React.FC<TopRightToastProps> = ({
  message,
  type = 'success',
  onClose,
}) => {
  if (!message) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 10000,
      }}
    >
      <Notification
        type={{ style: type, icon: true }}
        closable
        onClose={onClose}
      >
        {message}
      </Notification>
    </div>
  );
};
